import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_WEALTH_PROGRAM_DETAIL = 'WEALTH/FETCH_WEALTH_PROGRAM_DETAIL';

const apiCall = createApiCall(
  FETCH_WEALTH_PROGRAM_DETAIL,
  ({ id, ...params }: { id: string; [key: string]: any }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/wealth/programs/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
